import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#0A0E0A] mt-20" data-testid="site-footer">
      <div className="container-kv py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 border border-[#C8A97E] flex items-center justify-center">
              <span className="font-serif text-[#C8A97E] text-lg leading-none">K</span>
            </div>
            <span className="font-serif text-xl tracking-wide">Kratoven</span>
          </div>
          <p className="text-sm text-[#75726D] leading-relaxed">
            Premium Borneo kratom, sourced from ancient groves. Lab-tested, expertly cured, shipped from Borneo via DHL Express.
          </p>
        </div>

        <div>
          <h4 className="overline mb-5">Shop</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shop?strain=green" className="text-[#A8A5A1] hover:text-[#C8A97E]">Green Borneo</Link></li>
            <li><Link to="/shop?strain=super-green" className="text-[#A8A5A1] hover:text-[#C8A97E]">Super Green Borneo</Link></li>
            <li><Link to="/shop?strain=red" className="text-[#A8A5A1] hover:text-[#C8A97E]">Red Borneo</Link></li>
            <li><Link to="/shop?strain=brown" className="text-[#A8A5A1] hover:text-[#C8A97E]">Brown Borneo</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-5">Support</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/shipping" className="text-[#A8A5A1] hover:text-[#C8A97E]">Shipping Policy</Link></li>
            <li><Link to="/faq" className="text-[#A8A5A1] hover:text-[#C8A97E]">FAQ</Link></li>
            <li><Link to="/contact" className="text-[#A8A5A1] hover:text-[#C8A97E]">Contact</Link></li>
            <li><Link to="/about" className="text-[#A8A5A1] hover:text-[#C8A97E]">Our Story</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-5">Trust</h4>
          <ul className="space-y-3 text-sm text-[#A8A5A1]">
            <li className="flex items-center gap-2"><Leaf size={14} className="text-[#C8A97E]" />Lab-Tested</li>
            <li className="flex items-center gap-2"><Leaf size={14} className="text-[#C8A97E]" />100% Pure Borneo</li>
            <li className="flex items-center gap-2"><Leaf size={14} className="text-[#C8A97E]" />45-Day Guarantee</li>
            <li className="flex items-center gap-2"><Leaf size={14} className="text-[#C8A97E]" />DHL Express Worldwide</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-kv py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#75726D]">
          <span>© {new Date().getFullYear()} Kratoven. All rights reserved. kratoven.com</span>
          <span className="font-serif italic text-[#A8A5A1]">Rooted in Borneo. Refined for you.</span>
        </div>
      </div>
    </footer>
  );
}
